export enum OrganisationError {
  EmployerPropertySet = 'Bist du sicher, dass alle Employer aktualisiert werden sollen?',
}
